import { gzipSync, strToU8, zip, Zippable } from 'fflate';

import { ReportManifest } from '../../../../../../viewer/report/manifest';

/** The files of the report zip besides the manifest, by their path in it. */
export type ReportFiles = Record<string, Uint8Array>;

export type ReportPayload = { manifest: ReportManifest; files: ReportFiles };

/**
 * fflate tells files from folders with instanceof Uint8Array, which fails for arrays from another
 * realm, such as TextEncoder's in tests. A view of the same bytes is of this realm.
 */
const asFile = (data: Uint8Array) => new Uint8Array(data.buffer, data.byteOffset, data.byteLength);

/** A vectors layer's file: its content as gzipped JSON. */
export const gzipJson = (value: unknown): Uint8Array =>
  gzipSync(asFile(strToU8(JSON.stringify(value))));

/**
 * Zips the manifest and the files as report.zip, in fflate's workers so the page stays responsive.
 * Rasters and gzipped layers are already compressed, so they are only stored.
 */
export function zipReport({ manifest, files }: ReportPayload): Promise<Uint8Array> {
  const entries: Zippable = { 'manifest.json': asFile(strToU8(JSON.stringify(manifest))) };
  for (const [path, data] of Object.entries(files)) {
    entries[path] = [asFile(data), { level: 0 }];
  }

  return new Promise((resolve, reject) => {
    zip(entries, (error, data) => (error ? reject(error) : resolve(data)));
  });
}
